import  { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { singletonHook } from 'react-singleton-hook';
import * as LocationActions from "../redux/actions/LocationAction";
import { ErrorToast } from "../redux/actions/ToasterAction";
import _ from 'lodash'


let data = {}
const useLocationServicesFn = ()=>{  
    const [isLocationsInitialized, setIsLocationsInitialized] = useState(false)
    data = useSelector((state) => {
        return {states: state.location.states,
            locations: state.location.locations,
            programs: state.location.programs,
            primaryLocationId:state.location.primaryLocationId,
            isLocationsInitialized
        };
    });

    const token = useSelector((state)=>{
        return state.auth.token;
    })

    const dispatchSetup = useDispatch();
    const GetLocations = useCallback(async () => {    
        try{   
            var action = await LocationActions.GetLocations();
            dispatchSetup(action);
        } 
        catch(err){
            dispatchSetup(ErrorToast('Error', _.get(err, 'response.data.message') || err));
        }           

    }, [dispatchSetup])

    const GetStates = useCallback(async () => { 
        try{      
            var action = await LocationActions.GetStates();
            dispatchSetup(action);   
        } 
        catch(err){
            dispatchSetup(ErrorToast('Error', _.get(err, 'response.data.message') || err));
        }        

    }, [dispatchSetup])

    const GetPrograms = useCallback(async () => { 
        try{      
            var action = await LocationActions.GetPrograms();
            dispatchSetup(action);  
        }
        catch(err){
            dispatchSetup(ErrorToast('Error', _.get(err, 'response.data.message') || err));
        }          

    }, [dispatchSetup])



    useEffect(()=>{  
        if(token){      
            GetLocations().then(()=>{
                setIsLocationsInitialized(true);               
            });
            GetStates();  
            GetPrograms();           
        }   
    }, [ GetLocations, GetStates, GetPrograms, token])

    return data
}

export const useLocationServices = singletonHook(data, useLocationServicesFn);;